import { useTypedSelector } from '@k3/core';
import { useRef } from 'react';
import { Object3D, Box3, Vector3 } from 'three';

export const getBoundingBoxSize = (object: Object3D | undefined) => {
  if (!object) return new Vector3();

  const bbox = new Box3();
  bbox.expandByObject(object, true);

  const size = new Vector3();
  bbox.getSize(size);
  return size;
};

export const useBoundingBoxSize = (
  object: Object3D | undefined,
  onSizeChange?: (size: Vector3) => void
) => {
  const isLoading = useTypedSelector((state) => state.k3d.isSceneLoading);
  const size = useRef<Vector3>();

  if (!object || isLoading) return new Vector3();

  size.current = getBoundingBoxSize(object);
  if (onSizeChange) {
    onSizeChange(size.current);
  }

  return size.current;
};
